import { supabase } from "@/integrations/supabase/client";
import { useQuery } from "@tanstack/react-query";

const useRegressions = ({
  runId,
  runEndTime,
}: {
  runId: string | undefined;
  runEndTime: string | null | undefined;
}) => {
  // Query for regressions where this run is the failure
  const regressionsQuery = useQuery({
    queryKey: ["regressions", runId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("test_data_run_regressions")
        .select("id")
        .eq("failure_classification_run_result_id", runId!);
      if (error) throw error;
      return data || [];
    },
    enabled: !!runId,
  });

  // Query for the last previous successful run for the same medical_test_data
  const lastSuccessQuery = useQuery({
    queryKey: ["lastSuccessfulTestRun", runId],
    enabled: !!runId && !!runEndTime,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("test_classification_run_results")
        .select("id, run_end_time")
        .eq("success", true)
        .lt("run_end_time", runEndTime!)
        .order("run_end_time", { ascending: false })
        .limit(1);
      if (error) throw error;
      return data && data.length > 0 ? data[0] : null;
    },
  });

  return {
    lastSuccessQuery,
    regressionsQuery,
  };
};

export default useRegressions;
